import HolderTitle from './HolderTitle'

export default HolderTitle
